export const SHOW_TEMPLATE = {
  name: null,
  originalName: null,
  yearStart: null,
  yearEnd: null,
  duration: null,
  country: null,
  directors: null,
  cast: null,
  note: null,
  poster: null,
  photo: null,
  rating: null,
  csfdId: null,
  imdbId: null,
  tmdbId: null,
  youtubeLink: null,
  dataSource: null,
  leadParagraph: null,
  description: null,
  isPeriodic: null,
  broadcastsAssignable: true,
  importImages: null,
  automaticallyCreated: null,
  createdFromEpgSource: null,
  manuallyUpdated: null,
  timestampFirstManuallyUpdate: null,
  createdBy: null,
  originalRedGenre: null
}
